import { ChevronRightIcon } from './icons';

type TSliderButton = {
  position: 'left' | 'right';
  hidden?: boolean;
  onClick: () => void;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
};

export const SliderButton = ({ position, hidden, onClick, scrollContainerRef }: TSliderButton) => {
  const SliderIcon = position === 'left' ? <ChevronRightIcon className="-scale-x-100" /> : <ChevronRightIcon />;

  const offsetClass = position === 'left' ? 'left-0' : 'right-0';

  const halfContainerHeight = scrollContainerRef.current?.clientHeight ?
    scrollContainerRef.current.clientHeight / 2 + 6 :
    '50%';

  return (
    <div
      className={`absolute top-1/2 -translate-y-1/2 opacity-0 pointer-events-none
                tablet:opacity-100
                tablet:pointer-events-auto
                transition duration-500 ${offsetClass}`}
      style={{ top: halfContainerHeight }}

    >
      {!hidden && (
        <button type="button" onClick={onClick} data-hydrate="click" data-testid={`slider-button-${position}`}>
          {SliderIcon}
        </button>
      )}
    </div>
  );
};
